import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NaturezaVendaSituacaoModule } from '../situacao';

import { NaturezaVendaFilterModalComponent } from './modal';

@NgModule({
    imports: [
        SharedModule,
        NaturezaVendaSituacaoModule
    ],
    declarations: [
        NaturezaVendaFilterModalComponent
    ],
    exports: [
        NaturezaVendaFilterModalComponent
    ]
})
export class NaturezaVendaFilterModule { }
